const LANG_LABEL = { en: 'English', it: 'italiano' };

/**
 * Generate prompt for enhancing a node (steps or risks)
 * @param {Object} node
 * @param {'steps'|'risks'} type
 * @param {string} [lang='en']
 * @returns {string}
 */
export const generateEnhancePrompt = (node, type, lang = 'en') => {
  const langLine = `\n\nLINGUA: rispondi in ${LANG_LABEL[lang] ?? 'English'}.`;
  return type === 'steps'
    ? `"${node.title}" — scomponi in 4-5 idee concrete. Lista numerata, frasi secche.${langLine}`
    : `"${node.title}" — analisi rapida.\n\nPRO:\n- ...\n- ...\n\nCONTRO:\n- ...\n- ...\n\n2 pro, 2 contro. Sii onesto e diretto.${langLine}`;
};
